import { Laya } from "../../Laya";
import { Render2DProcessor } from "../display/Render2DProcessor";
import { Sprite } from "../display/Sprite";
import { TransformKind } from "../display/SpriteConst";
import { Text } from "../display/Text";
import { Event } from "../events/Event";
import { LayaGL } from "../layagl/LayaGL";
import { StatElement } from "../layagl/StatisticsContext";
import { Browser } from "./Browser";
import { Stat } from "./Stat";
export class StatUI {
    createUI() {
        this._pass = LayaGL.render2DRenderPassFactory.createRender2DPass();
        let sp = this._sp = new Sprite();
        this._pass.root = this._sp._struct;
        this._sp._struct.pass = this._pass;
        this._pass.doClearColor = false;
        let leftText = this._title = new Text();
        leftText.pos(5, 5);
        leftText.color = "#ffffff";
        leftText.name = "title";
        sp.addChild(leftText);
        let rightText = this._txt = new Text();
        rightText.singleCharRender = true;
        rightText.pos(100, 5);
        rightText.color = "#ffffff";
        rightText.name = "txt";
        sp.addChild(rightText);
        sp.graphics.clear();
        sp.graphics.alpha(0.5);
        sp.graphics.drawRect(0, 0, 1, 1, "#999999", null, null, true);
        Laya.stage.on(Event.RESIZE, this, this.updateSize);
    }
    updateSize() {
        let fontSize = Browser.onMobile ? 10 : 12;
        fontSize = Math.max(fontSize, fontSize / (Laya.stage._canvasTransform.getScaleX() * Laya.stage.clientScaleX));
        this._txt.fontSize = fontSize;
        this._title.fontSize = fontSize;
        this._txt.x = this._title.textWidth + 10;
        this._sp.size(this._title.textWidth + fontSize * 8, this._title.textHeight + 10);
        this._sp._globalTrans._spTransChanged(TransformKind.TRS);
    }
    _displayChild(node, display) {
        for (let child of node._children) {
            if (child._children.length > 0) {
                this._displayChild(child, display);
            }
            else {
                child._setDisplay(display);
            }
        }
        node._setDisplay(display);
    }
    show(x, y) {
        this._items = new Array();
        strArray.length = 0;
        for (let element of Stat.elements) {
            let name = StatElement[element];
            let title = name.replace(/^(T_|C_|M_|CT_)/, "").replace(/_/g, " ");
            let unit = "";
            let fractionDigits = 3;
            if (name.startsWith("CT_") || name.startsWith("C_"))
                fractionDigits = 0;
            else if (name.startsWith("M_"))
                unit = "M";
            else if (name.startsWith("T_"))
                unit = "ms";
            this._items.push({
                value: element,
                fractionDigits,
                unit
            });
            strArray.push(title);
        }
        if (!this._sp)
            this.createUI();
        this._title.text = strArray.join("\n");
        this._sp.pos(x || 0, y || 0);
        this._sp._parent = Laya.stage;
        this.updateSize();
        this._displayChild(this._sp, true);
    }
    hide() {
        if (!this._sp)
            return;
        this._title.text = null;
        this._txt.text = null;
        this._sp._parent = null;
        this._displayChild(this._sp, false);
    }
    update() {
        strArray.length = 0;
        for (let i = 0; i < this._items.length; i++) {
            let item = this._items[i];
            let datavalue = LayaGL.statAgent.getElementData(item.value);
            let str = datavalue.toFixed(item.fractionDigits).replace(digitPattern, '$1');
            if (str == "-0")
                str = "0";
            strArray.push(str + " " + item.unit);
        }
        this._txt.text = strArray.join("\n");
    }
    render() {
        this._pass && this._pass.fowardRender(Render2DProcessor.rendercontext2D, Render2DProcessor.renderTime);
    }
}
const strArray = [];
const digitPattern = /\.0*$|(\.\d*[1-9])0+$/;
Stat._statUIClass = StatUI;
